import { createApp } from 'vue/dist/vue.esm-bundler.js'
import floorplansApp from './FloorplansApp.vue'
import SidebarMenu from './components/SidebarMenu.vue'
import BuildingWireframe from './components/BuildingWireframe.vue'
import FloorplanPreview from './components/FloorplanPreview.vue'

// Vue.config.devtools = true

const app = createApp(floorplansApp)
app.component('SidebarMenu', SidebarMenu)
app.component('BuildingWireframe', BuildingWireframe)
app.component('FloorplanPreview', FloorplanPreview)

app.mount('#floorplansApp')
